module.exports = __webpack_public_path__ + "img/mz.06436e3c.png";